document.addEventListener('DOMContentLoaded', () => {
  // Change this selector to a wrapper that exists ONLY on your custom PDP
  const PDP_WRAPPER_SELECTOR = '.cammellatte-pdp';

  document.addEventListener('submit', async (e) => {
    const form = e.target;

    // Only intercept real product add-to-cart forms
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action || !form.action.includes('/cart/add')) return;

    // Only on your custom PDP
    if (!form.closest(PDP_WRAPPER_SELECTOR)) return;

    // Intercept
    e.preventDefault();

    const fd = new FormData(form);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd
      });

      if (!res.ok) {
        console.warn('Add to cart failed', await res.text());
        return;
      }

// Let theme update cart UI if it listens
document.dispatchEvent(new CustomEvent('cart:refresh'));

// Read theme setting from the wrapper: data-cart-type="drawer|page|message"
const wrapper = form.closest(PDP_WRAPPER_SELECTOR);
const cartType = (wrapper?.dataset.cartType || 'drawer').toLowerCase();

// If theme cart type is PAGE, go to /cart after successful add
if (cartType === 'page') {
  setTimeout(() => window.location.assign('/cart'), 150);
  return;
}

// If theme cart type is MESSAGE, stay on page (no drawer)
if (cartType === 'message') {
  return;
}

// Default: DRAWER — open drawer
const drawer =
  document.querySelector('cart-drawer') ||
  document.querySelector('[id*="cart-drawer"]') ||
  document.querySelector('[data-drawer="cart"]');

if (drawer && typeof drawer.open === 'function') {
  drawer.open();
  return;
}

// Fallback: click cart icon (drawer trigger)
const cartToggle =
  document.querySelector('[aria-controls*="cart"]') ||
  document.querySelector('[data-action*="cart"]') ||
  document.querySelector('.header__cart') ||
  document.querySelector('.header__cart-icon');

if (cartToggle) cartToggle.click();
else window.location.assign('/cart');

    } catch (err) {
      console.error(err);
    }
  }, true); // <-- capture phase is important
});